import { recycleBinUrl } from './recycleBinUrls'
import { draftReportUrl } from './draftReportUrl';
import { deliveredUrl } from './delivered';
import { archiveSignatureUrl } from './archive';
import { uploadUrl } from './upload';
import { signatureStatusUrl } from './status';


export class SIG {
    static readonly RECYCLE_BIN = new recycleBinUrl();
    static readonly DRAFT_REPORT = new draftReportUrl();
    static readonly DELIVERED = new deliveredUrl();
    static readonly ARCHIVED = new archiveSignatureUrl();
    static readonly UPLOAD = new uploadUrl();
    static readonly STATUS = new signatureStatusUrl();
}